import cn from "clsx";
import {
  CtaList,
  CtaListProps,
} from "design-system/components/primitives/cta-list/cta-list";
import {
  ComponentHeader,
  ComponentHeaderProps,
} from "design-system/components/primitives/component-header/component-header";
import { Alignment } from "design-system/types/types";

export interface CtaLinkListProps extends CtaListProps {
  headerContent?: ComponentHeaderProps;
  align?: Alignment;
}

/**
 *
 * ## See it in use on...
 * - The [class notes detail page](/story/snowflakes-alumni-example-pages-class-notes-detail-page--story)
 *
 */
export function CtaLinkList({
  align = "wide",
  headerContent,
  ...props
}: CtaLinkListProps) {
  const wrapperClass = cn(
    `hbs-global-align-${align}`,
    "hbs-component--cta-link-list",
  );

  return (
    <div className={wrapperClass}>
      <div className="hbs-cta-link-list">
        <ComponentHeader {...headerContent} />
        <CtaList {...props} />
      </div>
    </div>
  );
}
